var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finishSet"},[_c('el-row',[_c('el-col',{attrs:{"span":14}},[_c('previewMail',{attrs:{"formData":_vm.formData,"attachmentVos":_vm.attachmentVos}})],1),_c('el-col',{attrs:{"span":10}},[_c('previewDetail',{attrs:{"formData":_vm.formData,"signature":_vm.signature,"filterGroupArr":_vm.filterGroupArr}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }